const fr = {
    "Bem-vindo à Assembleia Nacional":"Bienvenue à l'Assemblée nationale",
    "Continuar":"Continuer",
    "Escolha seu Idioma":"Choisissez votre langue",
    "O Palácio da Assembleia Nacional":"Le Palais de l'Assemblée nationale",
    "História da Assembleia":"Histoire de l'Assemblée",
    "Galeria":"Galerie",
    "Quiz":"Quiz",
    "Símbolos":"Symboles",
    "Visita Virtual":"Visite virtuelle",
    "Constituição":"Constitution",
    "Teste seus conhecimentos acerca da Assembleia, Parlamento, Constituição e a República":"Testez vos connaissances sur l'Assemblée, le Parlement, la Constitution et la République",
    "Modo":"Mode",
    "Jogar":"Jouer",
    "15 segundos":"15 secondes",
    "Clássico":"Classique",
    "sem registros":"pas d'enregistrements",
    "sair":"sortez",
    "pontos":"points",
    "Tema":"Sujet",
    "Parabens acertaste todas as nossas questões":"Félicitations, vous avez répondu à toutes nos questions",
    "Tempo esgotado":"Temps est révolu",
    "Resposta errada":"Réponse incorrecte",
    "Fim do Quiz":"Fin du quiz",
    "Total de Pontos":"Total de Points",
    "Novo Record":"Nouveau Record",
    "seu nome":"votre nom",
    "salvar":"registrer",
    "responder novamente":"repondre",
    "lugar":"place",
    "Por favor degite seu nome":"S'il vous plaît entrez votre nom",
    "Atuais":"Actuel",
    "Antigos":"Ancien",
    "Autor":"Auteur",
    "Compositor":"Compositeur",
    "Este browser não suporta audio":"Ce navigateur ne prend pas en charge l'audio",
    "letra":"paroles de chanson",
    "Título":"Titre",
    "descrição":"description",
    "Bandeira":"Drapeau",
    "Hino":"Hymne",
    "Armas":"Armoiries",
    "Bandeira (1975-1992)":"Drapeau (1975-1992)",
    "Hino (1975-1992)":"Hymne (1975-1992)",
    "Armas (1975-1992)":"Armoiries (1975-1992)",
    "Constituição da República":"Constitution de la République",
    "fotos":"photos",
    "Carregando":"Chargement",
    "procurar por artigos":"rechercher des articles",
    "procurar":"rechercher",
    "Nenhum resultado encontrado":"Aucun résultat trouvé",
    "voltar":"retour",
    "Por favor degite um valor válido":"Veuillez entrer une valeur valide"
}

export default fr;